<template>
	<v-container
		grid-list-xl
		my-2
	>
		<v-layout
			row
			justify-center
			ma-0
		>
			<v-flex
				xs12
				md8
				pa-0
				ma-0
			>
				<slot name="alert"/>
			</v-flex>
		</v-layout>
		<v-layout
			row
			wrap
		>
			<v-flex
				xs12
				md4
				xl3
			>
				<v-container grid-list-xl>
					<v-layout
						row
						wrap
					>
						<v-flex
							v-if="errorSum > 0 || duplicateItems.length > 0"
							xs12
						>
							<v-card class="text-xs-center">
								<v-card-title class="info">
									<v-icon class="white--text pr-2">info</v-icon>
									<div class="headline white--text">Issues</div>
								</v-card-title>
								<v-card-text>
									<template v-if="duplicateItems.length > 0">
										<div class="subheading">Duplicate Article URL's</div>
										<div class="display-2">{{ duplicateItems.length | formatNumber }}</div>
										<v-btn
											v-if="$userCan('manage_reports') && !report.isArchivedOrParentArchived"
											flat
											@click="$router.push({ name: 'ReportIssues' })"
										>
											Remove Duplicates
										</v-btn>
									</template>
									<v-divider v-show="errorSum > 0 && duplicateItems.length > 0" class="mb-2"/>
									<template v-if="errorSum > 0">
										<div class="subheading">Article Issues</div>
										<div class="display-2">{{ errorSum | formatNumber }}</div>
										<v-btn
											v-if="$userCan('manage_reports') && !report.isArchivedOrParentArchived"
											flat
											@click="$router.push({ name: 'ReportIssues' })"
										>
											Fix Article Issues
										</v-btn>
									</template>
								</v-card-text>
							</v-card>
						</v-flex>
					</v-layout>
				</v-container>
			</v-flex>
			<v-flex
				xs12
				md8
				xl9
			>
				<v-container grid-list-xl>
					<v-layout
						row
						wrap
					>
						<v-flex
							xs12
							md6
						>
							<v-card class="text-xs-center">
								<v-card-title class="indigo">
									<v-icon
										color="white"
										class="pr-2"
										large
									>
										fa fa-facebook-square
									</v-icon>
									<div class="headline white--text">
										Facebook Shares
									</div>
								</v-card-title>
								<v-card-text>
									<h1 class="display-2">{{ facebookShares | formatNumber }}</h1>
								</v-card-text>
							</v-card>
						</v-flex>
						<!-- <v-flex xs12 md6>
							<v-card class="text-xs-center">
								<v-card-title class="blue">
									<v-icon color="white" class="pr-2" large>fa fa-twitter-square</v-icon>
									<div class="headline white--text">
										Twitter
									</div>
								</v-card-title>
								<v-card-text>
									<h1 class="display-2">{{ facebookShares | formatNumber }}</h1>
								</v-card-text>
							</v-card>
						</v-flex> -->
					</v-layout>
				</v-container>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
export default {
	computed: {
		report() {
			return this.$store.get('reports/currentReport');
		},
		articles() {
			return this.$store.get('articles');
		},
		errorSum() {
			let errors = 0;
			const articles = this.articles;
			if (articles.length === 0) {
				return errors;
			}
			for (let i = 0; i < articles.length; i++) {
				errors += articles[i].errors.length;
			}
			return errors;
		},
		facebookShares() {
			let shares = 0;
			const articles = this.articles;
			if (articles.length === 0) {
				return shares;
			}
			for (let i = 0; i < articles.length; i += 1) {
				if (articles[i].socialStats) {
					shares += articles[i].facebookShares;
				}
			}
			return shares;
		},
		duplicateItems() {
			// @Christian Landgren https://stackoverflow.com/questions/840781/get-all-non-unique-values-i-e-duplicate-more-than-one-occurrence-in-an-array
			const articles = this.articles;

			const unique = articles.map(article => ({ count: 1, url: article.url }))
				.reduce((a, b) => {
					a[b.url] = (a[b.url] || 0) + b.count;
					return a;
				}, {});

			const duplicates = Object.keys(unique).filter(a => unique[a] > 1);
			return duplicates;
		},
	},
};
</script>

<style>

</style>
